/**
 * App Language Provider
 * Add more locales here
 */
import { addLocaleData } from 'react-intl';
import arLang from './entries/ar_SA';
import enLang from './entries/en-US';

interface LocaleData {
  [key: string]: any;
}

const AppLocale: LocaleData = {
  en: enLang,
  ar: arLang,
};

addLocaleData(AppLocale.en.data);
addLocaleData(AppLocale.ar.data);

export default AppLocale;
